export { BaselineComponent } from './baseline.component';
export { remediate } from './remediate';
export const href =
    'https://learn.microsoft.com/en-gb/entra/identity/authentication/concept-certificate-based-authentication';
